module.exports = __webpack_public_path__ + "img/240824218_4285599064854113_8017739547634714139_n-800x400.884164ee.jpg";